import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../auth/AuthContext";
import { formatApiError } from "../api";
import { SEO } from "../components/SEO";
import { SITE } from "../data/siteData";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/admin/dashboard", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#161616] border border-white/15 rounded-md px-4 py-3 text-sm text-white placeholder:text-white/30 focus:outline-none focus:ring-2 focus:ring-brand/60 focus:border-brand transition-colors";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-6" data-testid="admin-login-page">
      <SEO title="Owner Login | Chinook K9" description="Chinook K9 owner dashboard login." path="/admin" />
      <div className="w-full max-w-md bg-[#121212] border border-white/10 rounded-2xl p-9">
        <img src={SITE.logo} alt="Chinook K9 logo" className="h-14 w-auto mx-auto mb-6" />
        <h1 className="font-heading text-2xl font-bold text-white text-center mb-1">Owner Dashboard</h1>
        <p className="text-sm text-white/50 text-center mb-8">Sign in to view leads and analytics</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-semibold text-white/90 mb-1.5">Email</label>
            <input type="email" required className={inputCls} data-testid="admin-email-input"
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="training@chinookk9.com" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-white/90 mb-1.5">Password</label>
            <input type="password" required className={inputCls} data-testid="admin-password-input"
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="w-full bg-brand text-white font-heading font-bold py-3.5 rounded-full hover:bg-red-700 transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading && <Loader2 size={17} className="animate-spin" />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
